import {
  TICKETS_REQUEST,
  TICKETS_SUCCESS,
  TICKETS_ERROR,

  TICKETS_CHECKS_REQUEST,
  TICKETS_CHECKS_SUCCESS,
  TICKETS_CHECKS_ERROR
} from "../actions/tickets";
import HTTP from "@/utils/http.js";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  tickets_get_status: "",
  tickets_once_loaded: false,
  tickets: { active: [], used: [], block: [] },

  checks_get_status: "",
  checks_once_loaded: false,
  checks: []
};

const getters = {
  getTickets: state => state.tickets,
  getActiveTickets: state => state.tickets.active,
  isTicketsLoading: state => state.tickets_get_status === "loading",
  isTicketsFailed: state => state.tickets_get_status === "error",
  ticketsOnceLoaded: state => state.tickets_once_loaded,
  getTicketsBalances() {
    let products = [];

    if (state.tickets.active)
      state.tickets.active.forEach((t) => {
        let product = products.find((p) => p.product_name === t.product_name);
        if (product) {
          product.active_quantity += t.quantity;
        } else {
          products.push({
            product_name: t.product_name,
            active_quantity: t.quantity,
            used_quantity: 0,
            block_quantity: 0,
          });
        }
      });
    if (state.tickets.used)
      state.tickets.used.forEach((t) => {
        let product = products.find((p) => p.product_name === t.product_name);
        if (product) {
          product.used_quantity += t.quantity;
        } else {
          products.push({
            product_name: t.product_name,
            active_quantity: 0,
            used_quantity: t.quantity,
            block_quantity: 0,
          });
        }
      });
    if (state.tickets.block)
      state.tickets.block.forEach((t) => {
        let product = products.find((p) => p.product_name === t.product_name);
        if (product) {
          product.block_quantity += t.quantity;
        } else {
          products.push({
            product_name: t.product_name,
            active_quantity: 0,
            used_quantity: 0,
            block_quantity: t.quantity,
          });
        }
      });
    return products;
  },


  getChecks: state => state.checks,
  isChecksLoading: state => state.checks_get_status === "loading",
  isChecksFailed: state => state.checks_get_status === "error",
  checksOnceLoaded: state => state.checks_once_loaded,
};

const actions = {
  [TICKETS_REQUEST]: ({ commit, dispatch }) => {
    commit(TICKETS_REQUEST);
    HTTP({ url: "tickets" })
      .then(resp => {
        commit(TICKETS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(TICKETS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [TICKETS_CHECKS_REQUEST]: ({ commit, dispatch }) => {
    commit(TICKETS_CHECKS_REQUEST);
    HTTP({ url: "tickets/checks" })
      .then(resp => {
        commit(TICKETS_CHECKS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(TICKETS_CHECKS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
};

const mutations = {
  [TICKETS_REQUEST]: state => {
    state.tickets_get_status = "loading";
  },
  [TICKETS_SUCCESS]: (state, data) => {
    state.tickets_get_status = "success";
    Vue.set(state, "tickets", data);
    state.tickets_once_loaded = true;
  },
  [TICKETS_ERROR]: state => {
    state.tickets_get_status = "error";
    state.tickets_once_loaded = true;
  },

  [TICKETS_CHECKS_REQUEST]: state => {
    state.checks_get_status = "loading";
  },
  [TICKETS_CHECKS_SUCCESS]: (state, data) => {
    state.checks_get_status = "success";
    Vue.set(state, "checks", data);
    state.checks_once_loaded = true;
  },
  [TICKETS_CHECKS_ERROR]: state => {
    state.checks_get_status = "error";
    state.checks_once_loaded = true;
  },

  [AUTH_LOGOUT]: state => {
    state.tickets_get_status = "";
    state.tickets_once_loaded = false;
    state.tickets = { active: [], used: [], block: [] };

    state.checks_get_status = "";
    state.checks_once_loaded = false;
    state.checks = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};